import request from '@/utils/request'

export function logout () {
	return request({
		url: '/api/merchant/account/logout',
		method: 'post'
	})
}
export function getBalanceNotice (query) {
	return request({
		url: '/api/merchant/business/setBalanceNotice',
		method: 'post',
		params: query
	})
}
// 会员中心_会员特权
export function getMemberInfo (query) {
	return request({
		url: '/api/merchant/api-members/membersGradeCenter',
		method: 'get',
		params: query
	})
}
export function closeBalanceNotice () {
	return request({
		url: '/api/merchant/business/closeBalanceNotice',
		method: 'post'
	})
}
export function getMyBalance () {
	return request({
		url: '/api/merchant/business/balance',
		method: 'get'
	})
}

export function getMyMaterial () {
	let query = { t: new Date().getTime() }// ie 相同参数不发请求的问题
	return request({
		url: '/api/merchant/business/current',
		method: 'get',
		params: query
	})
}

export function getBusinessInfo (query) {
	return request({
		url: '/api/merchant/business/info',
		method: 'get',
		params: query
	})
}

export function getServicesOpened () {
	return request({
		url: '/api/merchant/business/services-opened',
		method: 'get'
	})
}

export function getOverview () {
	return request({
		url: '/api/stat/record/home-stat',
		method: 'get'
	})
}

export function getServiceRecent () {
	return request({
		url: '/api/stat/record/home-recent',
		method: 'get'
	})
}

export function getServiceRecord () {
	return request({
		url: '/api/stat/record/home-pie',
		method: 'get'
	})
}

export function getServiceDayRecord () {
	return request({
		url: '/api/stat/record/home-24h',
		method: 'get'
	})
}

export function getServiceMonthRecord () {
	return request({
		url: '/api/stat/record/home-30d',
		method: 'get'
	})
}
export function getRotationList (query) {
	return request({
		url: '/api/merchant/home_page/select_num',
		method: 'get',
		params: query
	})
}
export function getBalanceProduct () {
	return request({
		url: '/api/merchant/business/product/myapi-homepage',
		method: 'get'
	})
}

export function getCountProduct () {
	return request({
		url: '/api/merchant/business/product/myproduct-index',
		method: 'get'
	})
}

export function getNotReadNum () {
	return request({
		url: '/api/merchant/site-message/getNotReadNum',
		method: 'get'
	})
}

export function getActivityDetail (query) {
	return request({
		url: '/api/merchant/activity/detail',
		method: 'get',
		params: query
	})
}



// WEBPACK FOOTER //
// ./src/services/home.js